<style> 
    .v-calendar .v-event{
        height: auto!important;
        margin-top: 4px;
    }
    .v-list .v-list-item--active{
          color: #0089ffd6!important;
    }
    /* This is for documentation purposes and will not be needed in your application */
    #create .v-speed-dial {
      position: absolute;
    }
    #create .v-btn--floating {
      position: relative;
    }
</style>
<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <!--<v-btn @click="pdf()"> pdf</v-btn>-->
          <v-btn class="mr-5" color="primary" dark @click="dialogprueba=true">
              Primer Evento
          </v-btn>
          <!--<v-btn @click="dialogc=true"><v-icon>print</v-icon></v-btn>-->
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            Hoy-
          </v-btn>
          <v-btn fab text small color="grey darken-3" @click="prev">
            <span class="material-icons">chevron_left</span>
          </v-btn> 
          <v-btn fab text small color="grey darken-4" @click="next">
            <span class="material-icons">chevron_right</span>
          </v-btn>   
           <v-toolbar-title class="text-capitalize" v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>      
          <v-spacer></v-spacer>      
          <v-btn icon @click="getEvents"><v-icon>refresh</v-icon></v-btn>  
        </v-toolbar>
      </v-sheet>
      <v-sheet min-height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          :events="events"
          locale="es-ES"
          :event-color="getEventColor"
          @click:event="showEvent"
          @change="getEvents"
        >
            <template #event="{event}" style="height: auto;width: 95%;margin-bottom: 1px;">
                <v-tooltip top :color="event.colort">
                <template v-slot:activator="{ on, attrs }">
                    <div style="padding: 4px;" v-bind="attrs" v-on="on">
                        <v-icon style="font-size: 20px;color: white;margin-right: 5px;">{{event.icon}}</v-icon>
                        <span style="white-space: normal;color:#ffffff;">{{event.name}}</span>
                    </div> 
                </template>
                <span>{{event.nactividad}}</span>
                </v-tooltip>             
            </template>
            <v-divider></v-divider>
        </v-calendar>
        <v-dialog v-model="dialog"  max-width="400"><!--Primera Actividad-->
              <v-card class="mx-auto" max-width="400">
                  <v-card-title>
                      <v-icon large left color="#0770c3">
                          phone   
                      </v-icon>
                      <span style="color:#0770c3;" class="title font-weight-bold">Primer Contacto</span>
                  </v-card-title>
                  <v-card-text class="text--primary ">
                      <v-form>
                          <v-select clearable v-model="nombrep" :items="prospectossn" label="*Prospecto">
                          </v-select>
                          <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          max-width="290"
                          dense
                          >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                :value="computedDateFormatpr"
                                clearable
                                label="*Fecha"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="date = null"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="date"
                                @change="menu = false"
                            ></v-date-picker>
                          </v-menu>                                               
                      </v-form>
                  </v-card-text>
                  <v-card-actions>
                      <v-list-item class="grow">
                          <v-row>
                              <v-list-item-avatar >
                                <span class="material-icons">
                                 face
                                </span>
                            </v-list-item-avatar>
                          </v-row>                            
                          <v-row>
                              <v-list-item-content>
                                  <v-list-item-title>{{name()}}</v-list-item-title>
                              </v-list-item-content>
                          </v-row>
                          <v-row align="center" justify="end">
                              <v-btn color="error" text @click="dialog=false">Cancelar</v-btn>
                              <v-btn style="color:#1583da;" dark text @click="guardarPrimeractividad()">Guardar</v-btn>
                          </v-row>
                      </v-list-item>
                  </v-card-actions>
              </v-card>              
        </v-dialog>
        <v-dialog v-model="selectedOpen" max-width="900"
            scrollable>  
              <v-card            
                min-width="350px"
                class="mx-auto"
              >
               <v-card-text v-model="hreporte" transition="slide-x-transition" v-if="hreporte"><!--Reporte de Actividades-->
                    <v-timeline align-top :dense=true >
                        <v-timeline-item                                    
                        v-for="(item, i) in items"                    
                        :key="i"
                        color="#0277BD"
                        :icon="item.icono"
                        fill-dot
                        >
                            <v-card
                                dark                      
                                color="#0277BD"                      
                            >
                                <v-toolbar v-if="item.completada" color="#0277BD">
                                <v-card-title class="title">{{item.nombrea}}</v-card-title>
                                <v-spacer></v-spacer>
                                <span>{{item.fechaactividad1}}</span>                      
                                <v-rating  
                                color="orange"
                                readonly v-model="item.idexpectativa"></v-rating>
                                </v-toolbar>
                                <v-toolbar v-else color="#ea1404">
                                <v-card-title style="heig:auto;" class="title">{{item.nombrea}}</v-card-title>
                                <v-spacer></v-spacer>                                                
                                <v-col sm="3" md="3" lg="3">
                                    <v-row style="text-align: center;">
                                    <v-col v-if="!item.reagendaractividad">                             
                                        <v-btn @click="reasignaractividad(item.idactividad)" style="border: 1px solid;font-size: 11px;height: 26px;" text>REAGENDAR</v-btn>
                                    </v-col>
                                    <v-col>
                                        <span>{{item.fechaactividad1}}</span>
                                    </v-col>
                                    </v-row>
                                </v-col>                      
                                <v-rating  
                                color="orange"
                                readonly v-model="item.idexpectativa"></v-rating>
                                </v-toolbar>
                                <v-card-text class="white text--primary">
                                    <v-row>
                                        <v-col v-if="item.iddocumento == 0">
                                        <p>{{item.reporte}}</p>
                                        </v-col>
                                        <v-col v-else>
                                            <v-expansion-panel>
                                                <v-expansion-panel-header>
                                                Item
                                                <template v-slot:actions>
                                                    <v-icon color="primary">
                                                    $expand
                                                    </v-icon>
                                                </template>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-col>
                                    </v-row>
                                    <v-row style="padding: 8px;">
                                        <v-col style="display: flex;padding: 3px;">
                                        <v-btn
                                            v-if="item.completada==false"
                                            color="#0277BD"
                                            class="mx-0"
                                            outlined
                                            @click="completara(item.idactividad)"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            Completar
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn                             
                                        v-if="item.tipoactividad==4 & item.completada==0"
                                        color="#0277BD"
                                        class="mx-0"
                                        outlined
                                        >                            
                                        Cotizacion
                                        </v-btn>
                                        <v-btn
                                        v-if="item.tipoactividad==6 & item.completada==0"
                                        color="#0277BD"
                                        class="mx-0"
                                        outlined
                                        @click="cartaPresentacion(item.idprospecto)"
                                        >
                                        Carta Presentación
                                        </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col style="display:flex;border-top: 1px solid #CFD8DC;">
                                        <v-list-item-avatar style="margin: 0;color: #546E7A;">
                                            <span class="material-icons">
                                            face
                                            </span>
                                        </v-list-item-avatar>
                                        <v-list-item-content style="color: #546E7A;">
                                            <v-list-item-title>{{item.nombreus}}</v-list-item-title>
                                        </v-list-item-content>
                                        </v-col>
                                    </v-row>                                     
                                </v-card-text>                      
                            </v-card>
                        </v-timeline-item>
                    </v-timeline>               
                </v-card-text>
                <v-card-text v-model="completar" transition="slide-x-transition" v-if="completar"><!--Completar Actividad-->
                  <v-spacer></v-spacer>
                  <v-row>
                    <v-col style="margin-bottom: 0;" v-if="ncompletada >= 2">
                      <!--<v-checkbox label="Terminar" v-on:change="noviable" v-model="terminaractividad" ></v-checkbox>-->
                    </v-col>
                  </v-row>                
                  <v-row>
                        <v-col >
                          <v-select v-on:change="noviable" label="Expectativa" v-model="expectativa" :items="expectativas"></v-select>
                        </v-col>
                        <v-col>
                          <v-select label="Actividad" :disabled="terminaractividad1" v-model="actividad" :items="tactividades"></v-select>
                        </v-col>                  
                        <v-col >
                          <v-menu
                          v-model="fechaa"
                          :disabled="terminaractividad1"
                          :close-on-content-click="false"
                          max-width="290"
                          dense
                          >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                :value="computedDateFormat"
                                clearable
                                label="*Fecha"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="datea = null"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="datea"
                                @change="fechaa = false"
                            ></v-date-picker>
                        </v-menu>  
                        </v-col>
                    <v-col sm="1" md="1" lg="1" v-if="terminaractividad1 == false">
                        <v-btn color="blue" v-if="actvidad2 === false" icon @click="actvidad2 = true"><v-icon>exposure_plus_1</v-icon></v-btn>
                        <v-btn color="red" v-if="actvidad2 === true" icon @click="actvidad2 = false"><v-icon>exposure_neg_1</v-icon></v-btn>
                    </v-col>
                  </v-row>
                  <!--<v-row v-if="actvidad2 === true">
                      <v-col>
                        <v-select label="Actividad" v-model="actividad2" :items="tactividades"></v-select>
                      </v-col>
                    <v-col>
                      <v-menu
                      v-model="fechaa2"
                      :close-on-content-click="false"
                      max-width="290"
                      dense
                      >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            :value="computedDateFormat2"
                            clearable
                            label="*Fecha"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            @click:clear="datea2 = null"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="datea2"
                            @change="fechaa2 = false"
                        ></v-date-picker>
                      </v-menu> 
                    </v-col>
                  </v-row>-->
                  <v-row>
                    <v-col>
                      <v-textarea outlined name="input-7-4" v-model="reporteactividad" label="Reporte"></v-textarea>
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Outlined textarea"
                        value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
                        ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row style="border-top: 1px solid rgb(207, 216, 220);">
                    <v-btn text color="error" @click="hreporte=true;completar=false;actvidad2=false">Cancelar</v-btn>
                    <v-btn text color="error" @click="completarActividad()">Guardar1</v-btn>                  
                  </v-row>
                </v-card-text>
              </v-card>
        </v-dialog>
          <v-dialog v-model="dialogprueba">
          <v-card class="mx-auto">
          <v-card-text>
                prueba
                <v-textarea
                v-model="textprueba"
                outlined
                name="input-7-4"
                label="Outlined textarea"
                value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
                ></v-textarea>
            </v-card-text>
          </v-card>
          </v-dialog>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios' 
import jsPDF from 'jspdf'
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

Vue.use(Loading);

  export default {
    data: () => ({
        textprueba:'',
        dialogprueba:false,
        focus: '',
        actividad:'',
        pruebadescritura:'',
        dialodload:false,
        reporteactividadn:'',
        expectativa2:'',
        actividadre:'',
        App:'',
        title:'',
        dialogp:false,
        viewdata:false,
        editorcp:'',
        editor: DecoupledEditor,
        hasChange: false,
        hasInit: false,
       // tinymceId: this.id,
        fullscreen: false,
        languageTypeList: {
          'en': 'en',
          'zh': 'zh_CN',
          'es': 'es_MX',
          'ja': 'ja'
        },
        isLoading: false,
        fullPage: true,
        dialogc:false,
        adjuntararchivo:'',
        archivos:[],
        contactos2:'',
        NameActividad:'',
        menuactividad:false,
        terminaractividad:false,
        actvidad2:false,
        toggle_exclusive: 2,
        toggle_multiple: [],
        confirmarVisita:false,
        on:'',
        attrs:'',
        date:'',
        datea2:'',
        dateare:'',
        today:'',
        hreporte:true,
        completar:true,
        reasignar:false,
        rating:'',
        menu:false,
        fechaa:false,
        fechaa2:false,
        title:'',
        text:'',
        idactividad:'',
        idprospecto:'',
        prospectossn:[],
        nombrep:'',
        fechaactividad:'',
        type: 'month',
        typeToLabel: {
          month: 'Month',
          week: 'Week',
          day: 'Day',
          '4day': '4 Days',
        },
        start: null,
        end: null,
        icon:'',
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        events: [],
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        nombre:null,
        nombreu:[],
        idnombreu:'',
        reporte:'',
        fecha:'',
        color:'',
        eventos:[],
        detalle:null,
        dialog:false,
        snackbar:false,
        currentlyEditing:false,
        items: [        
        ],
        expectativas:[],
        tactividades:[],
        reporteactividad:'',
        expectativa:'',
        datea:'',
        cartap:false,
        //////////////////////////////////
        chips: [],
        itemscon: ['Streaming', 'Eating'],
        colorActividad:'',
        actividadinactiva:false,
        idactividadpendiente:'',
        clientependiente:'',
        //title:'',
        fehaactividad:null,
        numactividad:0,
        fechastar:null,
        Numcompletar:0,
        ncompletada:0,
        hoy:'',
        ncustumer:'',
        contenido:'',
        ///
        searcho:'',
        searcho2:'',
        contactos:[],
        contactosprospecto:[],
        Copia:[],
        asunto:'',
        asunto2:'',
        contactoscc:'',
        contactoscp:'',
        cpasunto:'',
        contenidocp:'',
        fechaHoy:'',
        primera:false,
        segunda:false,
        terminaractividad1:false,
        diasSemana: new Array("Lunes","Martes","Miércoles","Jueves","Viernes","Sábado","Domingo"),
        idasignacion:0,
        /**------------- */
        transition: 'slide-y-reverse-transition',
        hover:false,
        fab: false,
        fling: false,
        tabs: null,
        direction: 'bottom',
        /*-------------*/
        prospectos:[],
        contactosview:[],
        editprospecto:{
            idprospecto:'',
            nombre:'',
            idpais:'',
            idestado:{text:'Select',value:'34'},
            idciudad:'',
            idestatus:'',
            direccion:'',
            producto:'',
            potencialV:'',
            industria:'',
            observaciones:'',
            zona:'',
            tio_cuenta:'',
            impo:'',
            expo:'',
            fcl:'',
            lcl:'',
            ltl:'',
            ftl:'',
            intermodal:'',
            maritimo:'',
            aereo:'',
            terrestre:'',
            asignacion:'',
            activo:'',
        },
        editcontact:{
            idcontacto:'',
            nombre:'',
            puesto:'',
            telefono:'',
            celular:'',
            correo:'',            
        },
        editedIndexp:-1,
        editprospectos:[],
        /**********************/
        paises:[],
        estados:[],
        estatus:[],
        tcuentas:['A','AA','AAA','VIP'],
        BtnCheck:'',
        BtnCheck2:'',
        checkall:false,
        checkall2:false,
        origenes:[],
        destinos:[],
        searchp:'',
        title:'',
        headers: [
            { text: 'OPCIONES', value: 'opciones', sortable: false },        
            { text: 'NOMBRE', value: 'nombre' },
            { text: 'PUESTO', value: 'puesto' },
            { text: 'TELÉFONO', value: 'telefono' },
            { text: 'CELULAR', value: 'celular' },
            { text: 'CORREO', value: 'correo', sortable: false },
            { text: 'ESTADO', value: 'activo' },
        ],
    }),
    mounted () {
        this.$refs.calendar.checkChange()    
        this.fechahoy();  
    },
    computed:{
        formTitle(){//si editedIndex es igual a menos uno estamos agregando un dato nuevo de lo contrario vamos a editar un dato existente
            return this.editedIndexp === -1 ? 'Ingresar Información de Prospecto' : 'Actualizar información de prospecto'
        },
        computedDateFormat() {
            return this.formatDate1(this.datea)
        },
        computedDateFormat2(){
            return this.formatDate1(this.datea2)
        },
        computedDateFormatr(){
            return this.formatDate1(this.dateare)
        },
        computedDateFormatpr(){
            return this.formatDate1(this.date)
        },
    },
    created () {        
        this.listar();
        this.select();        
    },
    methods: {
        fechahoy(){
            const date = new Date()
            const dateTimeFormat = new Intl.DateTimeFormat('Mx', { year: 'numeric', month: 'long', day: '2-digit' }) 
            const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat .formatToParts(date ) 
            this.fechaHoy = `${month} de ${day} del ${year }`;
        },
        select(){//mandamos llamar el controlador Puertos y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var expectativa=[];
            var tactividad=[];
            var cartas=[];
            var paisesArray=[];
            var estadosArray=[];
            var estatusArray=[];
            
            axios.get('api/Estatus/Select',configuracion).then(function(response){
                estatusArray=response.data;
                estatusArray.map(function(x){
                    me.estatus.push({text:x.nombre,value:x.idestatus});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Estados/Select',configuracion).then(function(response){
                estadosArray=response.data;
                estadosArray.map(function(x){
                    me.estados.push({text:'Select',value:'34'});
                    me.estados.push({text:x.nombre,value:x.idestado});
                    me.editprospecto.idestado = 'Select';
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Paises/Select',configuracion).then(function(response){                
                paisesArray=response.data;
                paisesArray.map(function(x){
                    me.paises.push({text:x.nombre,value:x.idpais});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Expectativas/Select',configuracion).then(function(response){
                expectativa=response.data;
                expectativa.map(function(x){
                    me.expectativas.push({text:x.nombre,value:x.idexpectativa});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Archivos/Select',configuracion).then(function(response){
                cartas=response.data;
                cartas.map(function(x){
                    me.archivos.push({text:x.nombre,value:x.idarchivo});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Tipoactividades/Select',configuracion).then(function(response){
                tactividad=response.data;
                tactividad.map(function(x){
                    me.tactividades.push({text:x.nombre,value:x.idtipo_actividad});
                });            
            }).catch(function(error){
                console.log(error);
            });
        },
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var prospectos = [];
            me.prospectossn = [];
            axios.get('api/Asignaciones/ListarProspectos/' + this.$store.state.usuario.idusuario ,configuracion).then(function(response){
                prospectos = response.data
                prospectos.map(function(x){
                    me.prospectossn.push({text:x.nombrep,value:x.idprospecto,idasignacion:x.idasignacion})
                    me.idasignacion = x.idasignacion
                    me.nombreu = x.nombreu
                    me.idnombreu = x.idusuario
                });
            }).catch(function(error){
            console.log(error);
            });               
        },
        getEvents(){//se cargan los eventos del ejecutivo
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion         
            let header={"Authorization" : "Bearer " + me.$store.state.token};        
            let configuracion ={headers:header};
            me.events = [];
            var events = [];
            var inactivo = false;
            var ultimaatividad = false;
            me.start = '';
            me.hoy = new Date();
            me.items = [];
            // var fecha =  hoy.getFullYear() + '-0' +(hoy.getMonth() + 1) + '-0' + (hoy.getDate());
            //var fechab =  hoy.getFullYear() + '-0' +(hoy.getMonth() + 1) + '-' + (hoy.getDate() + 2 );
            var fechaincompleta;
            me.dialodload = true;
            axios.get('api/Actividades/ListarActividadUs/' + me.$store.state.usuario.idusuario,configuracion).then(function(response){
                events=response.data;
                console.log('events')
                console.log(events)
                var diasSemana = new Array("Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado");  
                events.map(function(x){
                    var diaLetras;
                    var day;
                    var fecha1;
                    var diasDif;
                    var dias;
                    day = new Date(x.fechaactividad1);
                    //---------------------Sacamos Rango de dias transcurridos entre el dia de la actividad y el dia actual----------------------------------
                    fecha1 = new Date(x.fechaactividad1.substring(0,4),x.fechaactividad1.substring(5,7)-1,x.fechaactividad1.substring(8,10));
                    diasDif = me.hoy.getTime() - fecha1.getTime();
                    dias = Math.round(diasDif/(1000 * 60 * 60 * 24));
                    //-----------------------------------------------------------------------------------------------------------------------------------------
                    diaLetras = diasSemana[day.getDay()+1];
                    if(x.completada == false){
                        x.color = '#fd1100 !important';
                        x.colort = 'rgb(165 14 3) !important';
                        if(dias > 2){
                            if(diaLetras == 'Viernes'){
                                if(dias >= 4){
                                    inactivo=false;
                                }
                            }else{
                                inactivo=true;
                            }
                        }else{
                            if(dias <= 0){
                                x.color= 'rgb(255, 129, 91) !important';
                            }
                        }
                    }else{
                        x.color='rgb(15 114 193) !important';
                        x.colort='rgb(4 158 94) !important';                      
                    }
                    if(inactivo == false || ultimaatividad == false){
                        me.events.push({
                            idactividad:x.idactividad,
                            idprospecto:x.idprospecto,
                            icon:x.icono,
                            name:x.nombrep,
                            nombreus:x.nombreus,
                            start:x.fechaactividad1,
                            color:x.color,
                            colort:x.colort,
                            tipoactividad:x.idtipo_actividad,
                            nactividad:x.nactividad
                        });
                        if(inactivo == true && ultimaatividad == false){
                            ultimaatividad = true;
                            me.actividadinactiva = true;
                            me.idactividadpendiente = x.idprospecto;
                            me.clientependiente = x.nombrep;
                        }                
                    }
                });
                me.dialodload = false;
            }).catch(function(error){
                console.log(error);
            });
            me.start =  events.fechaactividad;
        },
        name(){//se obtiene el nombre del usuario
            return this.$store.state.usuario.nombre;
        },
        showEvent ({ nativeEvent, event }) {
            this.limpiar();
            this.hreporte = true;      
            this.completar = true;
            this.cartap = false;  
            this.reasignar = false;
            this.terminaractividad = false;
            this.actvidad2 = false;
            this.confirmarVisita = false;
            this.viewdata = false;
            this.NameActividad='Historial de Reportes';
            var actividades = [];
            this.ncompletada = 0;
            var reportes=[]; 
            this.items = [];
            
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            this.fechastar = event.start;
            this.ncustumer = event.name;
                axios.get('api/Actividades/ListarActividad/'+event.idprospecto,configuracion).then(function(response){
                    actividades=response.data;        
                    console.log('actividades')                
                    console.log(actividades)                
                    actividades.map(function(x){
                        if(x.completada == false){
                            me.ncompletada = me.ncompletada + 1;
                        } 
                    /*    me.items.push({
                            idactividad:x.idactividad,
                            idprospecto:x.idprospecto,
                            nombrea:x.nombrea,
                            icono:x.icono,
                            idexpectativa:x.idexpectativa,
                            expectativa:x.expectativa,
                            idusuario:x.idusuario,
                            nombreus:x.nombreus,
                            reporte:x.reporte,
                            fechaactividad1:x.fechaactividad1,
                            reagendaractividad:x.reagendaractividad,
                            completada:x.completada,
                            tipoactividad:x.idtipo_actividad
                        });*/
                    });
                }).catch(function(error){
                    console.log(error);
                });
            /*const open = () => {
                this.selectedEvent = event          
                setTimeout(() => this.selectedOpen = true, 10)
            }
            if (this.selectedOpen) {
                this.selectedOpen = false
                setTimeout(open, 10)
            } else {
                open()
            }*/
            this.selectedOpen = true;
            this.idprospecto  = event.idprospecto;
            nativeEvent.stopPropagation()
        },
        guardarPrimeractividad(){//Se guarda el primer evento con un prospecto.
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var diaLetras;
            let model=this;
            var prospectos=[];
            var tipoactividad;
            var f = new Date();
            var dia = new Date(model.date)
            var mes;
            var d;        
            diaLetras = model.diasSemana[dia.getDay()];
            if((f.getDate()) <= 9){
                d ='0' + f.getDate()
            }else{
                d =  f.getDate()
            }
            if((f.getMonth()+1) <= 9){
                mes = "0" + (f.getMonth() + 1)
            }else{
                mes = f.getMonth() + 1
            }        
            var hoy = f.getFullYear() + "-" + mes + "-" + d;
            if(model.nombrep == "" || model.date == ""){
                model.snackbar = true
                model.text = "Llenar todos los campos obligatorios *"
            }else{
                if(model.date >= hoy){
                    if(diaLetras == "Sábado" || diaLetras == "Domingo"){
                    model.snackbar = true 
                    model.text = 'No puedes agendar actividades en fin de semana'
                    }else{
                    var n;
                    for(n=0; n <= model.prospectossn.length; n++ ){
                        if(model.nombrep == model.prospectossn[n].value){
                        axios.post('api/Actividades/Crear',{
                            'idprospecto':model.nombrep,
                            'idasignacion':model.prospectossn[n].idasignacion,
                            'idtipo_actividad':11,
                            'idusuario':this.$store.state.usuario.idusuario,
                            'fechaactividad':model.date,
                            },configuracion).then(function(response){
                            model.limpiar();
                            model.listar();
                            //model.getEvents();
                            model.snackbar = true 
                            model.text = 'Actividad Guardada Correctamente'
                            model.dialog = false
                        }).catch(function(error){                                                
                            console.log(error); 
                            model.snackbar = true
                            model.text = error
                        });
                        n = model.prospectossn.length;
                    // this.select();
                        }
                    }
                    }
                }else{
                    model.snackbar = true
                    model.text = "La fecha debe ser mayor o igual a " + this.fechaHoy;
                }
            }
        },
        completarActividad(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            this.items = [];
            let model=this;
            var diaLetras;
            var diaLetras2;
            var dia = new Date(model.datea)
            var dia2 = new Date(model.datea2)
            diaLetras = model.diasSemana[dia.getDay()];
            diaLetras2 = model.diasSemana[dia2.getDay()];
            if(model.datea <= model.fechastar && model.terminaractividad1 == false ){
                model.snackbar = true                  
                model.text = 'La fecha debe ser mayor a la actividad por completar'
            }else{
                if(diaLetras == "Sábado" || diaLetras == "Domingo" || diaLetras2 == "Sábado" || diaLetras2 == "Domingo"){
                    model.snackbar = true                  
                    model.text = 'No puedes agendar actividades en fin de semana'
                }else{
                    if(model.terminaractividad1 == false){
                    if(model.actividad == 3){
                        this.primera = true;
                        this.enviarConfirmacion(model.idprospecto);
                    }else{
                        console.log('this.$store.state.usuario.rol')
                        console.log(this.$store.state.usuario.rol)
                        axios.put('api/Actividades/Actualizar',{
                            'idactividad':model.idactividad,
                            'idexpectativa':model.expectativa,
                            'reporte':model.reporteactividad,
                            'idprospecto':model.idprospecto,
                            'idtipo_actividad':model.actividad,
                            'idusuario':this.$store.state.usuario.idusuario,
                            'rol':this.$store.state.usuario.rol,
                            'fechaactividad':model.datea
                        },configuracion).then(function(response){
                            if(model.actvidad2 == true){
                                model.segundaActividad();
                            }else{
                                model.selectedOpen=false;
                                model.limpiar();
                                model.listar();
                                model.getEvents();
                                model.snackbar = true                  
                                model.text = 'Actividad Guardada Correctamente'
                            }
                        }).catch(function(error){
                            model.snackbar = true
                            model.text = error
                            console.log(error)
                        });
                    }
                    }else{
                        this.finalizarActividad();
                    }
                }  
            }
        },
        segundaActividad(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;
            var prospectos=[];
            var tipoactividad;
            if(model.actividad2 == 3){
                this.segunda = true;
                this.enviarConfirmacion(model.idprospecto);
            }else{
                axios.post('api/Actividades/SegundaActividad',{                
                    'idprospecto':model.idprospecto,    
                    'idtipo_actividad':model.actividad2,
                    'idusuario':this.$store.state.usuario.idusuario,
                    'fechaactividad':model.datea2,
                },configuracion).then(function(response){
                    model.selectedOpen=false;
                    model.limpiar();
                    model.listar();
                    model.getEvents();
                    model.snackbar = true                  
                    model.text = 'Actividades Guardadas Correctamente'
                }).catch(function(error){
                    console.log(error); 
                    model.snackbar = true
                    model.text = error
                });
                model.select(); 
            }
        },
        enviarConfirmacion(id){
            this.reasignar=false;        
            this.hreporte = false;
            this.completar = false;
            this.confirmarVisita = true;
            this.NameActividad='Confirmación de visita';        
            this.listarContacto(id);
        },
        reasignaractividad(id){//mostrar datos para reasignar fecha de actividad
            this.reasignar=true;
            this.idactividad = id;
            this.hreporte = false;
            this.completar = false;
            this.NameActividad='Reagendar Actividad';
        },
        completara(id){//se muestran los datos para completar actividad
            this.items = [];
            this.idactividad = id;
            this.hreporte = false;
            this.reasignar=false;
            this.completar = true;
            this.NameActividad='Completar Actividad';
        },
        cartaPresentacion(id){//se muestran datos para el envio de la carta de presentacion.
            this.hreporte = false;
            this.cartap = true;
            this.NameActividad='Carta de Presentación'; 
            this.listarContacto(id);
        },
        listarContacto(id){//se listan los contactos asignados pra la cuenta.
            var ContactosP = [];
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Contactos/ListarContacto/'+id,configuracion).then(function(response){            
                ContactosP=response.data;
                me.contactos=response.data;
                me.contactosview= response.data;
                ContactosP.map(function(x){
                me.contactosprospecto.push({text:x.correo,value:x.idcontacto})
                });
            }).catch(function(error){
                console.log(error);
            });
        },
        limpiar(){
            let model=this;  
            model.idactividad = '';
            model.expectativa = '';
            model.reporteactividad = '';
            model.idprospecto = '';
            model.actividad = '';
            model.idnombreu = '';
            model.date = null;
            model.datea = null;
            model.nombrep = '';
            model.terminaractividad1 = false;
        },
        noviable(){//Desabilitar los campos que no son necesarios cuando una cuenta no es viable.
            if(this.expectativa == 1 || this.terminaractividad == true){
                this.terminaractividad1 = true;
                this.datea='';
                if(this.expectativa == 1){
                this.actividad = 5;
                }else{
                this.actividad = '';}

            }else{
            this.terminaractividad1 = false;
            this.actividad = '';
            }
        },
        /**Dar formato a fecha**/
        formatDate1(date){
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        /*******Funciones calendario************/
        getEventColor (event) {       
            return event.color
        },
        setToday () {
            this.focus = this.today
        },
        prev () {
            this.$refs.calendar.prev()
        },
        next () {
            this.$refs.calendar.next()
        },
    },
  }
</script>